import {takeEvery} from 'redux-saga/effects'

import {
  SP_OLD_REPORT_CARD_LIST,
  SP_OLD_REPORT_CARD_VIEW,
} from '../../Actions/SpOldReportCard/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

/** Parent/student old report card (native /exam/report). */
function* dataSaga() {
  yield takeEvery(SP_OLD_REPORT_CARD_LIST, fetchData)
  yield takeEvery(SP_OLD_REPORT_CARD_VIEW, fetchData)
}

export default dataSaga
